import React from 'react';
import { Link } from 'react-router-dom';
import Logo from './Logo';
import styles from './Footer.module.css';

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className={styles.footer}>
      <div className={styles.inner}>
        <div className={styles.brand}>
          <Link to="/" className={styles.logo}>
            <Logo size={28} />
            <span className={styles.logoName}>Nieruchomy.pl</span>
          </Link>
          <p className={styles.tagline}>Portal ogłoszeń nieruchomości w Polsce</p>
        </div>
        <div className={styles.links}>
          <div className={styles.col}>
            <span className={styles.colTitle}>Ogłoszenia</span>
            <Link to="/ogloszenia?type=sprzedaz">Sprzedaż</Link>
            <Link to="/ogloszenia?type=wynajem">Wynajem</Link>
            <Link to="/ogloszenia?type=nowe">Nowe budownictwo</Link>
            <Link to="/dodaj">Dodaj ogłoszenie</Link>
          </div>
          <div className={styles.col}>
            <span className={styles.colTitle}>Konto</span>
            <Link to="/logowanie">Logowanie</Link>
            <Link to="/rejestracja">Rejestracja</Link>
            <Link to="/moje-ogloszenia">Moje ogłoszenia</Link>
          </div>
          <div className={styles.col}>
            <span className={styles.colTitle}>Informacje</span>
            <Link to="/o-nas">O nas</Link>
            <Link to="/regulamin">Regulamin</Link>
            <Link to="/prywatnosc">Polityka prywatności</Link>
          </div>
        </div>
      </div>
      <div className={styles.bottom}>
        <span>© {year} Nieruchomy.pl · Wszelkie prawa zastrzeżone</span>
        <span className={styles.rodo}>Serwis używa cookies wyłącznie do obsługi sesji logowania</span>
      </div>
    </footer>
  );
}
